export default "__VITE_ASSET__66s$n7$B__"